module.exports = __webpack_public_path__ + "media/images/themes/autumn_terracotta/main_bg-a79c30ef747c15ccc177abd021a546e9.png";